import { Link } from "react-router-dom";
import { Moon, Users, X, ClipboardCheck, BookOpen, ChevronRight, Check } from "lucide-react";
import { api } from "@/lib/api";

const STAGE_LABEL = { baseline: "Baseline Review", week6: "Week 6 Foundation Review", week12: "Week 12 Foundation Review" };

export function LifestyleStrip({ prompts, refresh }) {
  if (!prompts?.length) return null;
  const dismiss = async (id) => { await api.post(`/lifestyle/prompts/${id}/dismiss`).catch(() => {}); refresh(); };
  return (
    <div className="grid sm:grid-cols-2 gap-3" data-testid="lifestyle-strip">
      {prompts.map((p) => {
        const Icon = p.category === "RECOVER" ? Moon : Users;
        return (
          <div key={p.id} className="bg-card border border-border rounded-lg p-4 flex items-start gap-3" data-testid={`lifestyle-${p.category.toLowerCase()}`}>
            <div className="w-9 h-9 rounded-md flex items-center justify-center shrink-0 text-white" style={{ backgroundColor: p.category === "RECOVER" ? "#7C3AED" : "#F2B134" }}><Icon size={16} /></div>
            <div className="flex-1 min-w-0">
              <div className="text-[10px] uppercase tracking-widest text-muted-foreground">{p.category} · this week</div>
              <div className="mt-1 text-sm leading-snug">{p.text}</div>
            </div>
            <button onClick={() => dismiss(p.id)} aria-label="Done" className="w-11 h-11 -m-2 flex items-center justify-center text-muted-foreground hover:text-primary" data-testid={`lifestyle-dismiss-${p.category.toLowerCase()}`}><X size={16} /></button>
          </div>
        );
      })}
    </div>
  );
}

export function ReviewDueCard({ stage }) {
  if (!stage) return null;
  return (
    <Link to={`/app/review/${stage}`} className="block bg-card border border-primary/40 rounded-lg p-5 hover:bg-primary/5 transition-colors" data-testid="review-due-card">
      <div className="flex items-center justify-between gap-3">
        <div className="flex items-center gap-3">
          <div className="w-10 h-10 rounded-md bg-primary/10 text-primary flex items-center justify-center shrink-0"><ClipboardCheck size={18} /></div>
          <div>
            <div className="label-eyebrow">Optional · 3 minutes</div>
            <div className="font-head uppercase text-lg leading-snug">{STAGE_LABEL[stage]}</div>
          </div>
        </div>
        <ChevronRight size={18} className="text-primary shrink-0" />
      </div>
    </Link>
  );
}

export function LessonHero({ week, lesson, phaseLabel }) {
  return (
    <Link to={`/app/lesson/${week}`} className="block bg-foreground text-background rounded-lg p-7 hover:bg-primary transition-colors group" data-testid="lesson-hero-card">
      <div className="flex items-center justify-between gap-4">
        <div className="min-w-0">
          <div className="label-eyebrow !text-background/70 flex items-center gap-2"><BookOpen size={12} /> This week's lesson · Week {week} · {phaseLabel} · ~3 min</div>
          <div className="mt-2 font-head text-2xl md:text-3xl leading-snug uppercase">{lesson.title}</div>
          <div className="mt-2 text-xs text-background/70">Your action: {lesson.action_title}</div>
        </div>
        <div className="shrink-0 flex items-center gap-2 text-xs uppercase tracking-widest text-primary group-hover:text-primary-foreground">
          {lesson.completed ? <><Check size={14} /> Done</> : <>Watch / read <ChevronRight size={16} /></>}
        </div>
      </div>
    </Link>
  );
}
